export const COMPANY_DETAILS_INITIAL_FORM = {
  companyName: "",
  ownerName: "",
  gstNumber: "",
  panNumber: "",
  hsnCode: "",
  contactNumber: "",
  emailId: "",
  companyAddress: "",
  bankName: "",
  accountHolderName: "",
  accountNumber: "",
  ifscCode: "",
  branchName: "",
  signatureFileName: "",
  signatureDataUrl: "",
};

export const COMPANY_DETAILS_VALIDATION_RULES = {
  gstNumber: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/,
  panNumber: /^[A-Z0-9]{10}$/,
  contactNumber: /^[0-9]{10}$/,
  emailId: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  ifscCode: /^[A-Z]{4}0[A-Z0-9]{6}$/,
  accountNumber: /^[0-9]+$/,
};

export const isValidEmailList = (value) => {
  const raw = String(value || "").trim();
  if (!raw) return true;
  return raw
    .split(",")
    .map((email) => email.trim())
    .filter(Boolean)
    .every((email) => COMPANY_DETAILS_VALIDATION_RULES.emailId.test(email));
};

export const COMPANY_DETAILS_REQUIRED_FIELDS = [
  ["companyName", "Company Name"],
  ["ownerName", "Owner Name"],
  ["gstNumber", "GST Number"],
  ["panNumber", "PAN Number"],
  ["contactNumber", "Contact Number"],
  ["emailId", "Email ID"],
  ["companyAddress", "Company Address"],
];

/** Finance Management — add company modal (salary / payslip companies). */
export const FINANCE_COMPANY_REQUIRED_FIELDS = [
  ["companyName", "Name"],
  ["ownerName", "Owner Name"],
  ["contactNumber", "Contact Number"],
  ["emailId", "Email ID"],
  ["companyAddress", "Address"],
];

export const validateFinanceCompanyDetailsForm = (form) => {
  const nextErrors = {};

  FINANCE_COMPANY_REQUIRED_FIELDS.forEach(([key, label]) => {
    if (!String(form[key] || "").trim()) {
      nextErrors[key] = `${label} is required.`;
    }
  });

  if (
    String(form.contactNumber || "").trim() &&
    !COMPANY_DETAILS_VALIDATION_RULES.contactNumber.test(form.contactNumber)
  ) {
    nextErrors.contactNumber = "Contact Number must be exactly 10 digits.";
  }
  if (form.emailId && !isValidEmailList(form.emailId)) {
    nextErrors.emailId = "Enter valid email addresses separated by commas.";
  }

  return nextErrors;
};

export const formatCompanyDetailsField = (key, value) => {
  if (["gstNumber", "panNumber", "ifscCode"].includes(key)) {
    const formatted = value.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
    return key === "panNumber" ? formatted.slice(0, 10) : formatted;
  }
  if (key === "contactNumber") {
    return value.replace(/\D/g, "").slice(0, 10);
  }
  if (key === "accountNumber") {
    return value.replace(/\D/g, "");
  }
  return value;
};

export const validateCompanyDetailsForm = (form) => {
  const nextErrors = {};

  COMPANY_DETAILS_REQUIRED_FIELDS.forEach(([key, label]) => {
    if (!String(form[key] || "").trim()) {
      nextErrors[key] = `${label} is required.`;
    }
  });

  if (form.gstNumber && !COMPANY_DETAILS_VALIDATION_RULES.gstNumber.test(form.gstNumber)) {
    nextErrors.gstNumber = "Enter GST in valid format, e.g. 22AAAAA0000A1Z5.";
  }
  if (form.panNumber && !COMPANY_DETAILS_VALIDATION_RULES.panNumber.test(form.panNumber)) {
    nextErrors.panNumber = "PAN Number must contain exactly 10 letters or numbers.";
  }
  if (
    String(form.contactNumber || "").trim() &&
    !COMPANY_DETAILS_VALIDATION_RULES.contactNumber.test(form.contactNumber)
  ) {
    nextErrors.contactNumber = "Contact Number must be exactly 10 digits.";
  }
  if (form.emailId && !isValidEmailList(form.emailId)) {
    nextErrors.emailId = "Enter valid email addresses separated by commas.";
  }

  const bankFieldsEntered = Boolean(
    form.bankName ||
      form.accountHolderName ||
      form.accountNumber ||
      form.ifscCode ||
      form.branchName
  );

  if (bankFieldsEntered) {
    if (!form.accountNumber) {
      nextErrors.accountNumber = "Account Number is required when bank details are provided.";
    } else if (!COMPANY_DETAILS_VALIDATION_RULES.accountNumber.test(form.accountNumber)) {
      nextErrors.accountNumber = "Account Number must contain only numbers.";
    }

    if (!form.ifscCode) {
      nextErrors.ifscCode = "IFSC Code is required when bank details are provided.";
    } else if (!COMPANY_DETAILS_VALIDATION_RULES.ifscCode.test(form.ifscCode)) {
      nextErrors.ifscCode = "Enter IFSC in valid format, e.g. SBIN0001234.";
    }
  }

  return nextErrors;
};

export const buildCompanyProfilePayload = (form, { id, existingCompany = null } = {}) => {
  const timestamp = new Date().toISOString();
  return {
    ...form,
    id: id || existingCompany?.id || Date.now(),
    companyName: form.companyName.trim(),
    ownerName: form.ownerName.trim(),
    gstNumber: form.gstNumber.trim(),
    panNumber: form.panNumber.trim(),
    hsnCode: form.hsnCode.trim(),
    contactNumber: form.contactNumber.trim(),
    emailId: form.emailId.trim(),
    companyAddress: form.companyAddress.trim(),
    bankName: form.bankName.trim(),
    accountHolderName: form.accountHolderName.trim(),
    accountNumber: form.accountNumber.trim(),
    ifscCode: form.ifscCode.trim(),
    branchName: form.branchName.trim(),
    createdAt: existingCompany?.createdAt || timestamp,
    updatedAt: timestamp,
  };
};
